import type { Specialty } from 'interfaces/specialty';
import type { Province } from '@billing/validation/payor';

type SpecialtyDefinition = Omit<Specialty, 'province'>;

const mbSpecialtyDefinitions: SpecialtyDefinition[] = [
  { code: '01', description: 'Internal Medicine' },
  { code: '011', description: 'Internal Medicine - Neurology' },
  { code: '012', description: 'Internal Medicine Geriatrics' },
  { code: '013', description: 'Internal Medicine Rheumatology' },
  { code: '014', description: 'Internal Medicine - Cardiology' },
  { code: '015', description: 'Internal Medicine - Gastroenterology' },
  { code: '016', description: 'Internal Medicine - Nephology' },
  {
    code: '017',
    description: 'Internal Medicine - Allergy/Clinical Immunology',
  },
  { code: '018', description: 'Internal Medicine - Genetics' },
  { code: '019', description: 'Internal Med Out-of-Province Agreement' },
  { code: '02', description: 'Paediatrics' },
  { code: '029', description: 'Paediatrics Out-of-Province Agreement' },
  { code: '03', description: 'Psychiatry' },
  { code: '039', description: 'Psychiatry Out-of-Province Agreement' },
  { code: '040', description: 'Surgery - Oral' },
  { code: '041', description: 'Surgery - General' },
  { code: '042', description: 'Surgery - Cardiac' },
  { code: '043', description: 'Surgery - Plastic & Reconstructive' },
  { code: '044', description: 'Surgery - Urology' },
  { code: '045', description: 'Surgery - Orthopaedic' },
  { code: '046', description: 'Surgery - Neurological' },
  { code: '047', description: 'Surgery - Dental' },
  { code: '048', description: 'Surgery - Periodontal' },
  { code: '049', description: 'Surgery Out-of-Province Agreement' },
  { code: '051', description: 'Ophthalmology' },
  { code: '052', description: 'Otorhinolaryngology' },
  { code: '053', description: 'Optometry' },
  { code: '059', description: 'E.E.N.T. Opt. Out-of-Province Agreement' },
  { code: '06', description: 'Dermatology' },
  { code: '069', description: 'Dermatology Out-of-Province Agreement' },
  { code: '07', description: 'Radiology' },
  { code: '071', description: 'Radiology - In Hospital' },
  { code: '072', description: 'Radiology - Professional' },
  { code: '073', description: 'Radiology - Nuclear Medicine Split' },
  { code: '074', description: 'Radiology - Nuclear Medicine Prof' },
  { code: '075', description: 'Radiology - Nuclear Medicine Total' },
  { code: '076', description: 'Radiology - Diagnostic' },
  { code: '079', description: 'Radiology Out-of-Province Agreement' },
  { code: '08', description: 'Pathology' },
  { code: '081', description: 'Pathology - Anatomical' },
  { code: '082', description: 'Pathology - Hematology' },
  { code: '083', description: 'Pathology - Medical Biochemistry' },
  { code: '084', description: 'Pathology - Medical Microbiology' },
  { code: '085', description: 'Pathology - Neuropathology' },
  { code: '089', description: 'Pathology Out-of-Province Agreement' },
  { code: '09', description: 'Obstetrics & Gynecology' },
  { code: '091', description: 'Perinatal Medicine' },
  {
    code: '099',
    description: 'Obstetrics & Gynecology Out-of-Province Agreement',
  },
  { code: '10', description: 'Anesthesiology' },
  { code: '109', description: 'Anaesthesia Out-of-Province Agreement' },
  { code: '11', description: 'General Practice (Out of Province)' },
  { code: '111', description: 'General Practice (Urban)' },
  { code: '112', description: 'General Practice (Rural)' },
  { code: '113', description: 'Emergency Medicine' },
  { code: '114', description: 'Community Medicine (Public Health)' },
  { code: '115', description: 'Allied Health Professional' },
  { code: '116', description: 'Family Practice – Rural' },
  { code: '119', description: 'General Practice (Out of Province Agreement)' },
  { code: '12', description: 'Physical Medicine' },
  { code: '121', description: 'Physical Medicine - Chiropractic' },
  { code: '122', description: 'Physical Medicine – Northern Chiropractic' },
  { code: '129', description: 'Chiropractic Out-of-Province Agreement' },
  { code: '130', description: 'Int. Med - Career Medical Scientist' },
  { code: '131', description: 'Internal Medicine - Endocrinology' },
  { code: '132', description: 'Internal Medicine - Hematology' },
  { code: '133', description: 'Int. Medicine - Infectious Disease' },
  { code: '134', description: 'Internal Medicine - Respiratory' },
  { code: '141', description: 'Surgery-Vascular' },
  { code: '142', description: 'Surgery - Thoracic' },
  { code: '143', description: 'Surgery - Paediatrics General' },
  { code: '15', description: 'Malignant Disease Specialist' },
  { code: '150', description: 'Oncology - Medical' },
  { code: '151', description: 'Oncology - Gynecological' },
  { code: '152', description: 'Oncology - Urological' },
  { code: '153', description: 'Oncology - Paediatrics' },
  { code: '154', description: 'Oncology - Community' },
  { code: '155', description: 'Oncology - General Surgery' },
  { code: '156', description: 'Oncology - Otorhinolaryngology' },
  { code: '158', description: 'Oncology - Radiology' },
  { code: '159', description: 'Oncology - Out-Of-Prov Agreement' },
  { code: '200', description: 'RN - Nurse Practitioner' },
  { code: '201', description: 'Mid-Wife' },
  { code: '205', description: 'Physician Assistant' },
];

const bcSpecialtyDefinitions: SpecialtyDefinition[] = [
  { code: '00', description: 'General Practice' },
  { code: '01', description: 'Dermatology' },
  { code: '02', description: 'Neurology' },
  { code: '03', description: 'Psychiatry' },
  { code: '05', description: 'Obstetrics & Gynaecology' },
  { code: '06', description: 'Ophthalmology' },
  { code: '07', description: 'Otolaryngology' },
  { code: '08', description: 'General Surgery' },
  { code: '09', description: 'Neurosurgery' },
  { code: '10', description: 'Orthopaedics' },
  { code: '11', description: 'Plastic Surgery' },
  { code: '12', description: 'Cardiac Surgery' },
  { code: '13', description: 'Urology' },
  { code: '14', description: 'Paediatrics' },
  { code: '15', description: 'Internal Medicine' },
  { code: '16', description: 'Radiology' },
  { code: '17', description: 'Laboratory Medicine' },
  { code: '18', description: 'Anaesthesia' },
  { code: '19', description: 'Paediatric Cardiology' },
  { code: '20', description: 'Physical Medicine and Rehabilitation' },
  { code: '21', description: 'Public Health (Community Medicine)' },
  { code: '23', description: 'Occupational Medicine' },
  { code: '24', description: 'Geriatric Medicine' },
  { code: '26', description: 'Cardiology' },
  { code: '28', description: 'Emergency Medicine' },
  { code: '29', description: 'Medical Microbiology' },
  { code: '30', description: 'Chiropractors' },
  { code: '31', description: 'Naturopaths' },
  { code: '32', description: 'Physical Therapy' },
  { code: '33', description: 'Nuclear Medicine' },
  { code: '34', description: 'Osteopathy' },
  { code: '37', description: 'Oral Surgeons' },
  { code: '38', description: 'Podiatrists' },
  { code: '39', description: 'Optometrist' },
  { code: '40', description: 'Dental Surgeons' },
  { code: '41', description: 'Oral Medicine' },
  { code: '42', description: 'Orthodontists' },
  { code: '43', description: 'Massage Practitioner' },
  { code: '44', description: 'Rheumatology' },
  { code: '45', description: 'Clinical Immunization and Allergy' },
  { code: '46', description: 'Medical Genetics' },
  { code: '47', description: 'Vascular Surgery' },
  { code: '48', description: 'Thoracic Surgery' },
  { code: '49', description: 'Respirology' },
  { code: '51', description: 'Endocrinology' },
  { code: '53', description: 'Critical Care Medicine' },
  { code: '56', description: 'Gastroenterology' },
  { code: '59', description: 'Nephrology' },
  { code: '67', description: 'Infectious Disease' },
  { code: '68', description: 'Acupuncture' },
  { code: '74', description: 'Hematology Oncology' },
  { code: '78', description: 'RN - In Certified Practice' },
  { code: '80', description: 'Midwives of BC' },
  { code: '81', description: 'Registered Nurse - PHCO Only' },
  { code: '82', description: 'Nutritionist/Dietician - PHCO Only' },
  { code: '83', description: 'Counsellor/Psychologist - PHCO Only' },
  { code: '84', description: 'Educator - PHCO Only' },
  { code: '85', description: 'Licensed Practical Nurse - PHCO Only' },
  { code: '86', description: 'Medical Office Assistance - PHCO Only' },
  { code: '87', description: 'Nurse Practitioner' },
  { code: '88', description: 'Respiratory Therapist - PHCO Only' },
  { code: '89', description: 'Home Support - PHCO Only' },
  { code: '91', description: 'Pharmacist - PHCO Only' },
  { code: '92', description: 'Occupational Therapist - PHCO Only' },
  { code: '93', description: 'Other Allied Health Professional - PHCO Only' },
];

const withProvince = (
  province: Province,
  definitions: SpecialtyDefinition[]
): Specialty[] => definitions.map((specialty) => ({ ...specialty, province }));

export const specialtyCodes = withProvince('MB', mbSpecialtyDefinitions);
const bcSpecialtyCodes = withProvince('BC', bcSpecialtyDefinitions);

export const getSpecialtyCodes = (province?: Province | null): Specialty[] =>
  province === 'BC' ? bcSpecialtyCodes : specialtyCodes;
